import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { ClientDataService } from '../../data-services/client.service';
import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import { ClientEditComponent } from './client.edit';
import { DialogService } from 'primeng/dynamicdialog';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { HasClaimDirective } from '../../security/has-claim.directive';

@Component({
   selector: 'app-client-list',
   templateUrl: './client.list.html',
   providers: [DialogService],
   imports: [CommonModule, TableModule, HasClaimDirective]
})
export class ClientListComponent implements OnInit {
  
  constructor(private clientDataService: ClientDataService,
    public dialogService: DialogService) {
   }

   clients;
   statuses: SelectItem[] = [];
   totalRecords: number;
   cols: any[];
   loading: boolean;
  selectedStatus: SelectItem;
  viewref: any = null;

  @ViewChild('container', { read: ViewContainerRef }) viewContainerRef: ViewContainerRef;    


   ngOnInit() {
     //var secUser = AppComponent.currentUser;
      this.cols = [
        { field: 'code', header: 'Code' },
        { field: 'Name', header: 'Name' },
        { field: 'State', header: 'State' },
      ];
     this.loading = true;
   }

   public handleSearchKey(event, reqlist) {
      if (event.keyCode == 13) {
         reqlist.filterGlobal(event.target.value, 'contains');
         event.preventDefault();
      }
   }

   lastLoad: LazyLoadEvent;
   public loadLazy(event: LazyLoadEvent) {
     this.loading = true;
     if (event) {
       this.lastLoad = event;
     } else {
       this.lastLoad.first = 0;
       event = this.lastLoad;
     }
     this.clientDataService.getListPage(event.first, event.rows, event.sortField, event.sortOrder, event.filters).subscribe((data: any) => {
        this.totalRecords = data.totalRows;
        this.clients = data.rows;
        this.loading = false;
      });
   }

  openEdit(id) {
    var title = "";
    if (id) {
      title = "Edit Client"
    } else {
      title = "Add Client"
    }
    const ref = this.dialogService.open(ClientEditComponent, {
      header: title,
      data: {
        id: id
      },
      width: '800px'
    });

    ref.onClose.subscribe((pkg) => {
      if (pkg && this.lastLoad) {
        this.loadLazy(this.lastLoad);
      }
    });
  }
}


